<script>
import appConfig from "@/app.config";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import ODuyuru from "@/models/oduyuru";
import useVuelidate from "@vuelidate/core";
import authenticate from "@/models/authenticate";
export default {
  mixins: [Api, Sabit, ODuyuru, authenticate],
  page: {
    title: "Duyurular",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
  },
  data() {
    return {
      v$: useVuelidate(),
      FormData: {},
      KurumAdi: JSON.parse(localStorage.getItem("config")).KURUM_ADI,
      ErrorMessage: "",
      loginbutton: false,
      KURUM_ADI: JSON.parse(localStorage.getItem('config')).KURUM_ADI,
      showPassword: false,
      benihatirla: "true",
      currentYear: new Date().getFullYear(),
    };
  },

  methods: {
    Get() {

    },

    Login() {

      this.ErrorMessage = "";
      this.v$.FormData.$touch();
      if (!this.v$.FormData.$invalid) {
        this.loginbutton = true;

        this.ActionsLoginSessionKey(this.FormData).then((res) => {
          console.log(res)
          if (res == true) {
           /* if (this.benihatirla == "true") {
              let cookiessifreleme = this.$CryptoJS.AES.encrypt(JSON.stringify({ Email: this.FormData.Email, Password: this.FormData.Password }), process.env.VUE_APP_SHA_KEY).toString();
              window.$cookies.set("ecampususer", cookiessifreleme, "1y", null, JSON.parse(localStorage.getItem("config")).COOKIES_DOMAIN);
            }*/
            window.location.href = "/";
          } else {
            this.ErrorMessage = res.Message;
            this.loginbutton = false;
          }
        });

      }


    },
    DogrulamaMaili() {
      if (this.FormData.Email) {
        this.loginbutton = true;
        this.ActionsSendVerification(this.FormData.Email).then((res) => {
          if (res) {

            this.$toast.success("Doğrulama Maili Gönderildi");
          }
          else {
            this.$toast.error("Doğrulama Maili Gönderilemedi!");
          }

          this.loginbutton = false;
        });
      }
    },
    SifreSifirlamaMaili() {

      if (this.FormData.Email) {
        this.loginbutton = true;
        this.ActionsForgotPassword({
          "Email": this.FormData.Email
        }).then((res) => {
          if (res) {

            this.$toast.success("Şifre Sıfırlama Maili Gönderildi");
          }
          else {
            this.$toast.error("Şifre Sıfırlama Maili Gönderilemedi!");
          }

          this.loginbutton = false;
        });
      }
    }
  },
};
</script>

<template>
  <div class="login-page">
    <div class="login-visual">
      <div class="visual-content">
        <div class="visual-logo">
          <img src="https://elasoft.com.tr/assets/logo/elasoft-wordmark-v5.png" alt="logo" />
        </div>

        <div class="visual-copy">
          <h1>{{ KURUM_ADI }}<br />Talep Yönetim Sistemi</h1>
          <p>Kurumsal taleplerinizi tek noktadan oluşturun, takip edin ve sonuçlandırın.</p>

          <div class="visual-features">
            <span><i class="mdi mdi-shield-check-outline"></i> Güvenli Erişim</span>
            <span><i class="mdi mdi-cloud-outline"></i> Bulut Altyapı</span>
            <span><i class="mdi mdi-sync"></i> Anlık Takip</span>
          </div>
        </div>
      </div>

      <svg class="visual-ribbon" viewBox="0 0 1000 1000" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="ribbonA" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stop-color="#ffd9d6" />
            <stop offset="100%" stop-color="#e2231c" />
          </linearGradient>
          <linearGradient id="ribbonB" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stop-color="#ffb3ae" />
            <stop offset="100%" stop-color="#c81e18" />
          </linearGradient>
          <linearGradient id="ribbonC" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stop-color="#ffe4e1" />
            <stop offset="100%" stop-color="#ff5c52" />
          </linearGradient>
        </defs>
        <path d="M -100,780 C 150,650 300,850 500,700 C 700,550 800,750 1000,380" stroke="url(#ribbonA)"
          stroke-width="130" fill="none" stroke-linecap="round" opacity="0.92" vector-effect="non-scaling-stroke" />
        <path d="M -100,680 C 180,850 320,600 540,760 C 760,920 850,600 1000,480" stroke="url(#ribbonB)"
          stroke-width="105" fill="none" stroke-linecap="round" opacity="0.88" vector-effect="non-scaling-stroke" />
        <path d="M -80,600 C 200,500 340,700 560,550 C 780,400 870,600 1000,300" stroke="url(#ribbonC)"
          stroke-width="78" fill="none" stroke-linecap="round" opacity="0.92" vector-effect="non-scaling-stroke" />
        <path d="M -100,725 C 150,595 300,795 500,645 C 700,495 800,695 1000,325" stroke="rgba(255,255,255,0.32)"
          stroke-width="9" fill="none" stroke-linecap="round" vector-effect="non-scaling-stroke" />
        <path d="M -80,565 C 200,465 340,665 560,515 C 780,365 870,565 1000,265" stroke="rgba(255,255,255,0.4)"
          stroke-width="5" fill="none" stroke-linecap="round" vector-effect="non-scaling-stroke" />
      </svg>
    </div>

    <div class="login-panel">
      <div class="login-form-wrap">
        <div class="login-eyebrow">TALEP YÖNETİM SİSTEMİNE GİRİŞ</div>
        <h2 class="login-title">Oturum açın</h2>

        <b-form class="login-form" @submit.prevent="Login">
          <b-form-group class="mb-3" id="input-group-1" label-for="input-1">
            <label class="field-label" for="input-1">Kurum Kullanıcı Adı <span class="req">*</span></label>
            <div class="input-icon-group">
              <i class="mdi mdi-account-outline field-icon"></i>
              <b-form-input id="input-1" class="form-control" v-model="FormData.Email" type="text"
                :placeholder="$t('login.page.kullaniciadi')"
                :class="{ 'is-invalid': submitted && $v.FormData.Email.$error }"></b-form-input>
            </div>
            <div v-if="submitted && $v.FormData.Email.$error" class="invalid-feedback d-block">
              <span v-if="!$v.FormData.Email.required">{{ $t("login.page.requirederror") }}</span>
              <span v-if="!$v.FormData.Email.email">{{ $t("login.page.emailerror") }}</span>
            </div>
          </b-form-group>

          <b-form-group class="mb-2" id="input-group-2" label-for="input-2">
            <label class="field-label" for="input-2">Şifre <span class="req">*</span></label>
            <div class="input-icon-group">
              <i class="mdi mdi-lock-outline field-icon"></i>
              <b-form-input id="input-2" class="form-control" v-model="FormData.Password"
                :type="showPassword ? 'text' : 'password'" :placeholder="$t('login.page.parola')" :class="{
                  'is-invalid': submitted && $v.FormData.Password.$error,
                }"></b-form-input>
              <i class="mdi field-icon field-icon-toggle"
                :class="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                @click="showPassword = !showPassword"></i>
            </div>
            <div v-if="submitted && !$v.FormData.Password.required" class="invalid-feedback d-block">
              {{ $t("login.page.requirederror") }}
            </div>
          </b-form-group>

          <div class="error-alert" v-if="ErrorMessage">
            <i class="mdi mdi-alert-circle-outline"></i>
            <span>{{ ErrorMessage }}</span>
          </div>

          <div class="login-row">
 
            <button :disabled="loginbutton == true" @click="SifreSifirlamaMaili()" type="button"
              class="login-link">{{ $t("login.page.sifremiunuttum") }}</button>
          </div>

          <b-button :disabled="loginbutton == true" type="submit" variant="primary" class="login-btn mt-3">
            <span v-if="loginbutton" class="spinner-border spinner-border-sm me-2" role="status"></span>
            <template v-else><i class="mdi mdi-arrow-right me-1"></i></template>
            {{ $t("login.page.giris") }}
          </b-button>
        </b-form>

        <div class="login-form-wrap mb-4" v-if="sifre_sifirla">
          <div>
            <h5>{{ $t("login.page.parolasifirlama") }}</h5>
            <p>{{ $t("login.page.asagidakiformueksiksizdoldurun") }}</p>
          </div>
          <b-form class="p-0" @submit.prevent="tryToLogIn">
            <b-form-group class="mb-3" id="input-group-3" label-for="input-3">
              <b-form-input id="input-3" class="form-control" v-model="FormData.Email" type="text"
                :placeholder="$t('login.page.kullaniciadi')"></b-form-input>
              <div v-if="submitted && $v.FormData.Email.$error" class="invalid-feedback">
                <span v-if="!$v.FormData.Email.required">{{ $t("login.page.requirederror") }}</span>
                <span v-if="!$v.FormData.Email.email">{{ $t("login.page.emailerror") }}</span>
              </div>
            </b-form-group>
            <b-form-group class="mb-3" id="input-group-4" label-for="input-4">
              <b-form-input id="input-4" class="form-control" v-model="password" type="text"
                :placeholder="$t('login.page.tckimlikno')"></b-form-input>
              <div v-if="submitted && !$v.FormData.Password.required" class="invalid-feedback">
                {{ $t("login.page.requirederror") }}
              </div>
            </b-form-group>

            <b-button type="submit" variant="primary" class="btn-block login-btn">{{ $t("login.page.sifremisifirla")
              }}</b-button>
          </b-form>
        </div>

        <div class="login-footer">© {{ currentYear }} {{ KURUM_ADI }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
* {
  box-sizing: border-box;
}

.login-page {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
}

/* ---------- Left / visual side ---------- */

.login-visual {
  position: relative;
  flex: 1.4;
  height: 100%;
  background: #ffffff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: clamp(220px, 40vh, 420px);
}

.visual-content {
  position: relative;
  z-index: 2;
  padding: 0 64px;
}

.visual-logo {
  margin-bottom: 56px;
}

.visual-logo img {
  height: 34px;
  width: auto;
}

.visual-copy {
  max-width: 560px;
}

.visual-copy h1 {
  font-size: 2.6rem;
  font-weight: 800;
  line-height: 1.15;
  color: #17181c;
  margin: 0 0 18px;
  letter-spacing: -0.5px;
}

.visual-copy p {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #5b6068;
  max-width: 460px;
  margin: 0 0 22px;
}

.visual-features {
  display: flex;
  flex-wrap: wrap;
  gap: 22px;
}

.visual-features span {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  font-weight: 500;
  color: #3a3d44;
}

.visual-features i {
  color: #e2231c;
  font-size: 1.05rem;
}

.visual-ribbon {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}

/* ---------- Right / form panel ---------- */

.login-panel {
  flex: 1;
  min-width: 420px;
  height: 100%;
  background: #f5f5f7;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  overflow-y: auto;
}

.login-form-wrap {
  width: 100%;
  max-width: 380px;
}

.login-eyebrow {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 1.2px;
  color: #8a8f98;
  margin-bottom: 8px;
}

.login-title {
  font-size: 1.7rem;
  font-weight: 700;
  color: #17181c;
  margin: 0 0 28px;
}

.login-form {
  width: 100%;
}

.field-label {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: #33363d;
  margin-bottom: 6px;
}

.req {
  color: #e2231c;
}

/* ---------- Inputs ---------- */

.input-icon-group {
  position: relative;
  display: flex;
  align-items: center;
}

.field-icon {
  position: absolute;
  left: 14px;
  font-size: 1.05rem;
  color: #9a9fa8;
  pointer-events: none;
}

.field-icon-toggle {
  left: auto;
  right: 14px;
  pointer-events: auto;
  cursor: pointer;
  transition: color 0.15s ease;
}

.field-icon-toggle:hover {
  color: #33363d;
}

.form-control {
  background: #ffffff;
  border: 1px solid #dcdfe4;
  border-radius: 10px;
  color: #17181c;
  height: 46px;
  padding-left: 42px;
  padding-right: 40px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.form-control::placeholder {
  color: #a7abb2;
}

.form-control:focus {
  color: #17181c;
  background: #ffffff;
  border-color: #e2231c;
  box-shadow: 0 0 0 3px rgba(226, 35, 28, 0.14);
}

.login-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;
}

.form-check {
  color: #33363d;
  font-size: 0.85rem;
}

/* ---------- Error alert ---------- */

.error-alert {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 2px;
  margin-bottom: 10px;
  padding: 10px 14px;
  border-radius: 10px;
  background: rgba(226, 35, 28, 0.08);
  border: 1px solid rgba(226, 35, 28, 0.25);
  color: #c81e18;
  font-size: 0.85rem;
}

.error-alert i {
  font-size: 1.05rem;
  flex-shrink: 0;
}

.is-invalid {
  border-color: #e2231c !important;
}

.invalid-feedback {
  color: #e2231c !important;
  font-size: 0.8rem;
  margin-top: 4px;
}

/* ---------- Buttons / links ---------- */

.login-btn {
  width: 100%;
  height: 48px;
  background: #e2231c !important;
  border: none !important;
  border-radius: 10px;
  font-weight: 600;
  letter-spacing: 0.2px;
  box-shadow: 0 8px 20px rgba(226, 35, 28, 0.22);
  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
}

.login-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 10px 24px rgba(226, 35, 28, 0.32);
  filter: brightness(1.05);
}

.login-btn:active:not(:disabled) {
  transform: translateY(0);
}

.login-btn:disabled {
  opacity: 0.7;
}

.login-link {
  background: none;
  border: none;
  padding: 0;
  font-size: 0.82rem;
  font-weight: 500;
  color: #e2231c;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.15s ease;
}

.login-link:hover {
  text-decoration: underline;
}

.login-link:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.login-footer {
  margin-top: 28px;
  text-align: center;
  font-size: 0.75rem;
  color: #9a9fa8;
}

/* ---------- Responsive ---------- */

@media (max-width: 992px) {
  .login-visual {
    display: none;
  }

  .login-panel {
    flex: none;
    width: 100%;
    min-width: 0;
  }
}

@media (max-width: 480px) {
  .login-panel {
    padding: 24px 20px;
  }
}
</style>
